/* Field Notes article: carousel arrows, click-to-enlarge screenshots, smooth jump links. */
(function () {
  if (window.bsFieldNotes) return;
  window.bsFieldNotes = true;

  function initRail(root) {
    var rail = root.querySelector('.fn-rail'), prev = root.querySelector('[data-fn-prev]'), next = root.querySelector('[data-fn-next]');
    if (!rail || !prev || !next || rail.dataset.ready) return;
    rail.dataset.ready = '1';
    var step = function () { var c = rail.querySelector('.fn-card'); return c ? c.getBoundingClientRect().width + 20 : 400; };
    var sync = function () {
      prev.disabled = rail.scrollLeft < 4;
      next.disabled = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 4;
    };
    prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function initZoom(root) {
    var zoom = root.querySelector('.fn-zoom');
    if (!zoom || zoom.dataset.ready || typeof zoom.showModal !== 'function') return;
    zoom.dataset.ready = '1';
    root.querySelectorAll('[data-fn-full]').forEach(function (b) {
      b.addEventListener('click', function () {
        var img = zoom.querySelector('img');
        img.src = b.getAttribute('data-fn-full');
        img.alt = (b.querySelector('img') || {}).alt || '';
        zoom.showModal();
      });
    });
    zoom.addEventListener('click', function (e) { if (e.target === zoom) zoom.close(); });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-fn-cards]').forEach(function (s) { initRail(s); initZoom(s); });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.bs-fn a[href^="#"]');
    if (!a) return;
    var t = document.getElementById(a.getAttribute('href').slice(1));
    if (!t) return;
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    history.replaceState(null, '', '#' + t.id);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
